import { Component, Inject, OnInit,ViewChild,ElementRef } from '@angular/core';
import { Subscription, throwError} from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ImportDialogComponent } from '../architecture/import-dialog/import-dialog.component';
import { HttpClient, HttpErrorResponse, HttpEventType  } from '@angular/common/http';
import { catchError } from 'rxjs/operators'

import { LogoService } from '../services/logo.service';
import { ThemeService } from 'src/app/theme/theme.service';

@Component({
  selector: 'app-logo-manager',
  templateUrl: './logo-manager.component.html',
  styleUrls: ['./logo-manager.component.scss']
})
export class LogoManagerComponent implements OnInit {

  private logosData$: Subscription;
  logosData:any;

  isLoading = false;
  searchLogos = "";

  accountId;

  // sLogosBind is an array to work with the material list component,
  // sLogoSelected is a single number that gets update to the array value
  // when it is updated
  sLogosBind=[];
  sLogoSelected = "";

  // should make all this generic! fields should jsut be defined
  sOriginalName = "";
  sOriginalFile = "";
  sOriginalCompany = "";
  sOriginalSource = "";
  sName = "";
  sFile = "";
  sCompany = "";
  sSource = "";

  public fieldMessage = {};

  showEditable = false;
  showSave = false;
  showCancel = false;
  showDelete = false;
  showAdd = true;

  @ViewChild('nameField') nameField: any;
  @ViewChild('file') fileField: any;

  constructor(
    private http: HttpClient,
    public logoService: LogoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LogoManagerComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {

    this.showEditable = true; //this.data["showEditable"];
    this.accountId = 1; //this.data["accountId"]; this is just a dummy value for now - logomanager is just for admins

    if(this.data["logoid"]){
      this.sLogosBind = [this.data["logoid"]];
      this.sLogoSelected = this.data["logoid"];
    } else {
      this.sLogosBind = [""];
      this.sLogoSelected = "";
    }

    // wire up the logos
    this.logosData$ = this.logoService.logos$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){                  
          if(responsedata.loading){
            this.isLoading = true;
          } else {
            this.isLoading = false;
            this.logosData = responsedata["data"];   
            
            // if a logo is selected then pick it after load
            // if one isn't then check if its an add and if it is
            // then select it
            if(this.sLogoSelected!="add") {
              this.selectionChange([this.sLogoSelected]);
              // scroll it into view
              setTimeout(() => {
                if(document.getElementById("logo-list-"+this.sLogoSelected) != null)
                document.getElementById("logo-list-"+this.sLogoSelected).scrollIntoView();
              },100)

            } else {
              if(responsedata["newid"]){
                this.selectionChange([responsedata["newid"]]);
                // scroll it into view
                setTimeout(() => {
                  //console.log("logo-list-"+responsedata["newid"])
                  if(document.getElementById("logo-list-"+responsedata["newid"]) != null)
                document.getElementById("logo-list-"+responsedata["newid"]).scrollIntoView();
                },100)
              }
            }
          }          
        }
      }
    )

    this.logoService.loadLogos();
  }


  add(){
    // set fields to blank
    this.sOriginalName = "";
    this.sOriginalFile = "";
    this.sOriginalCompany = "";
    this.sOriginalSource = "";
    this.sName = "";
    this.sFile = "";
    this.sCompany = "";
    this.sSource = "";
    this.showEditable = true;
    this.showSave = false;
    this.showCancel = true;
    this.showDelete = false;
    this.showAdd = true;    

    this.sLogoSelected = "add";

    // hit the add file button
    this.fileField.nativeElement.click();
  }

  delete(){
    const dialogRef = this.dialog.open(OKCancelDialog, {
      width: '350px',
      data: {title:"Confirm", text: "Do you want to delete this logo?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result=="ok"){
        let data = {
          accountid:this.accountId,
          id:this.sLogoSelected
        }
    
        this.logoService.deleteLogos(data);
        this.selectionChange("");

      }      
    });
  }


  
  close(){
    this.dialogRef.close({"action":"cancel"});
  }

  select(){
    this.dialogRef.close({"action":"select","logoid":this.sLogoSelected});
  }

  save():void {

    let id = this.sLogoSelected=="add" ? "" : this.sLogoSelected;

    let data = {
      accountid:this.accountId,
      id:id,
      name:this.sName,
      file:this.sFile,
      company:this.sCompany,
      source:this.sSource
    }

    this.logoService.updateLogos(data);

  }

  cancel():void {
    
    this.sName = this.sOriginalName;
    this.sFile = this.sOriginalFile;
    this.sCompany = this.sOriginalCompany;
    this.sSource = this.sOriginalSource;
    this.fieldMessage["name"] = "";
    this.showSave = false;
    this.showCancel = false;

    if(this.sLogoSelected=="add") this.sLogoSelected = "";
    
  }

  selectionChange(event){

    // console.log("----selected:" + event[0])
    if(event[0]==undefined) return;

    this.sLogoSelected = event[0];

      // find the right one
      let vdata = this.logosData.filter(x => (x["id"] == this.sLogoSelected))
      if(vdata.length>0){
        this.sName = vdata[0].name        
        this.sFile = vdata[0].file
        this.sCompany = vdata[0].company
        this.sSource = vdata[0].source
        this.showSave = false;
        this.showCancel = false;
        this.showDelete = true;        

        this.sOriginalName = this.sName;        
        this.sOriginalFile = this.sFile;
        this.sOriginalCompany = this.sCompany;
        this.sOriginalSource = this.sSource;

        setTimeout(() => {
        this.nameField.nativeElement.focus();
        },100)

        this.fieldMessage["name"] = "";
        this.fieldMessage["file"] = "";


      } else {
        // not in list must be after a delete so clear fields
        
          this.sName = "";
          this.sFile = "";
          this.sCompany = "";
          this.sSource = "";
          this.showSave = false;
          this.showCancel = false;
          this.showDelete = false;
          this.sLogoSelected = "";

          this.fieldMessage["name"] = "";
          this.fieldMessage["file"] = "";
              
  }

  }

  nameChange(ev){    
    if(this.sLogoSelected=='') return;

    let val = ev.target.value

    if(val != this.sOriginalName){
      this.showSave = true;
      this.showCancel = true;
    } else {
      this.showSave = false;
      this.showCancel = false;
    }

    // don't allow a blank save
    if(val.trim()==""){
      this.showSave = false;
      this.fieldMessage["name"] = "Field is required"
    }

    // don't allow duplicate
    let id = this.sLogoSelected;
    if(this.logosData.filter(r => ( r["name"].toLowerCase().trim() == val && r["id"] != id )).length > 0 ){      
      this.showSave = false;
      this.fieldMessage["name"] = "There is already a logo with this name"
    }

  }


  companyChange(ev){    
    if(this.sLogoSelected=='') return;

    if(ev.target.value != this.sOriginalCompany){
      this.showSave = true;
      this.showCancel = true;
    } else {
      this.showSave = false;
      this.showCancel = false;
    }

  }

  sourceChange(ev){    
    if(this.sLogoSelected=='') return;

    if(ev.target.value != this.sOriginalSource){
      this.showSave = true;
      this.showCancel = true;
    } else {
      this.showSave = false;
      this.showCancel = false;
    }

  }

  getLogosList(){
    
    if(this.searchLogos.trim()=="") return this.logosData  
    return this.logosData.filter(x => x.name.toLowerCase().includes(this.searchLogos.trim().toLocaleLowerCase() 
    || x.file.toLowerCase().includes(this.searchLogos.trim().toLocaleLowerCase())
    || x.company.toLowerCase().includes(this.searchLogos.trim().toLocaleLowerCase())
    ))
    
  }


  uploadFile = (files) => {
    if (files.length == 0) {
      return;
    }
    
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    
    const importDialogRef = this.dialog.open(ImportDialogComponent, {
      width: '350px',
      height: '300px',
      data: {title:"Import", text: "Importing Logo ...", loading:true}
    });

    importDialogRef.afterClosed().subscribe(result => {
      // reload the version data - this will get the latest one
      // this.versionService.loadVersions(this.sAccount["id"]);
    })      

    let id = this.sLogoSelected=="add" ? "" : this.sLogoSelected;
    
    this.http.post('/api/logos/import?id=' + id + "&aid=" + this.accountId, formData, {reportProgress: true, observe: 'events'})
      .pipe(catchError(err => {        

        if(err["error"]["errors"]){
          importDialogRef.componentInstance.data = {title:"Import", text: "Logo file is too large. Max size is 1 Meg.", loading:false};
          return throwError(err);  

        } else if (err.error["message"]){
          importDialogRef.componentInstance.data = {title:"Import", text: "Problem with the logo load:<br>" + err.error["message"].replace(/\|/g,"</br>"), loading:false};
          return throwError(err);  
        } else {
          importDialogRef.componentInstance.data = {title:"Import", text: "Problem loading the logo", loading:false};
          return throwError(err);  
        }

      })
        
      )
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress){
         //  this.progress = Math.round(100 * event.loaded / event.total);
        }
        else if (event.type === HttpEventType.Response) {
          importDialogRef.componentInstance.data = {title:"Import", text: "Loaded file: " + event.body["message"].replace(/\|/g,"</br>"), loading:false};
          importDialogRef.close();

          // if its an add then there is no id - just update the file field, otherwise load the list
          if(this.sLogoSelected!="add"){
            this.logoService.loadLogos();
          } else {
            this.sFile = event.body["message"];
            if(this.sName.trim()==""){
              this.sName = this.sFile.replace(".png","");
            }
            this.sSource = "Upload";
            this.showSave = true;
            this.showCancel = true;

            this.nameChange({target:{value:this.sName}});
            
            setTimeout(() => {
              this.nameField.nativeElement.focus();
              this.nameField.nativeElement.setSelectionRange(0, this.sName.length);
            },200)                        
            

          }        
        }
      })

    
  }

}


@Component({
  selector: 'okcanceldialog',
  styleUrls: ['./logo-manager.component.scss'],
  template: `<h3 class="mat-dialog-title aip-dialog-title">{{data.title}}</h3>
  <div class="mat-dialog-content aip-dialog-text">
    {{data.text}}
</div>
  <div class="mat-dialog-actions" align="end">
    <button class="mat-focus-indicator aip-button mat-raised-button mat-button-base mat-primary" (click)="ok()">OK</button>
    <button class="mat-focus-indicator aip-button-alt mat-raised-button mat-button-base" (click)="cancel()" cdkFocusInitial>Cancel</button>
</div>
    `
})
export class OKCancelDialog {

  constructor(
    public dialogRef: MatDialogRef<OKCancelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ok(): void {
      this.dialogRef.close("ok");
    }

  cancel(): void {
    this.dialogRef.close("cancel");
  }


}
